import { useEffect } from "react";

export function useSeo({ title, description, canonical }) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    const metaDesc = document.querySelector('meta[name="description"]');
    const prevDesc = metaDesc ? metaDesc.getAttribute("content") : null;
    if (metaDesc) metaDesc.setAttribute("content", description);

    const canonicalEl = document.querySelector('link[rel="canonical"]');
    const prevCanonical = canonicalEl ? canonicalEl.getAttribute("href") : null;
    if (canonicalEl) canonicalEl.setAttribute("href", canonical);

    return () => {
      document.title = prevTitle;
      if (metaDesc && prevDesc !== null) metaDesc.setAttribute("content", prevDesc);
      if (canonicalEl && prevCanonical !== null) canonicalEl.setAttribute("href", prevCanonical);
    };
  }, [title, description, canonical]);
}
